function open_popup_moneyback() {
  const slider = document.querySelector('#moneyBackGuaranteeSlider');
  if (slider) {
    slider.classList.add('open');
    document.body.classList.add('overflow-hidden');
  }
}

function closeMoneyBackGuaranteeDrawer() {
  const slider = document.querySelector('#moneyBackGuaranteeSlider');
  if (slider) {
    slider.classList.remove('open');
    document.body.classList.remove('overflow-hidden');
  }
}
document.addEventListener('click', (event) => {
  if (!event.target.closest('.moneyBackGuaranteeSlider_white') && !event.target.closest('.money_back_button')) {
    closeMoneyBackGuaranteeDrawer();
  }
});